import { css, styled } from "../../../../../styles";

export const MainContainer = styled("div", {
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",

  width: "100%",
  height: "100%",

  columnGap: "3px",
  rowGap: "5px",
});

export const LoginContainer = styled("div", {
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  padding: "10px",
});

export const InputsContainer = styled("div", {
  display: "flex",
  flexDirection: "row",
  alignItems: "center",
  justifyContent: "center",

  columnGap: "10px",

  marginTop: "20px",
});

export const ErrorMessage = styled("p", {
  fontFamily: "$openSans",
  fontWeight: "600",
  lineHeight: "16px",
  fontSize: "$text-md",

  margin: "38px 0 34px 0",
  color: "$error-light",
});

export const ListContainer = styled("div", {
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",

  width: "80%",
  height: "500px",

  //   backgroundColor: "white",
  //   border: "1px solid var(--colors-gray-40);",
});

// css

export const inputCss = css({
  width: "300px",
});

export const loginButtonStyles = css({
  marginTop: "28px",
});
